export const SEARCH_PREVIEW_SKELETON = 'search-preview-skeleton';
export const SEARCH_PREVIEW_SKELETON_SUGGESTION = 'search-preview-skeleton-suggestion';
export const SEARCH_PREVIEW_SKELETON_HEADER = 'search-preview-skeleton-header';
export const PRODUCTS_COUNT = 12;
export const SUGGESTIONS_COUNT = 5;
